import { render } from "./CelebrationProjectEmbed.vue?vue&type=template&id=45ae11d0&scoped=true"
import script from "./CelebrationProjectEmbed.vue?vue&type=script&lang=js"
export * from "./CelebrationProjectEmbed.vue?vue&type=script&lang=js"

import "./CelebrationProjectEmbed.vue?vue&type=style&index=0&id=45ae11d0&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45ae11d0"]])

export default __exports__